module.exports = __webpack_public_path__ + "img/TradingView-icon14.80386359.svg";